/**
 * UserVerification throws a popup if the user does not have
 * a verified email
  */
 
import filters from '@/utility/filters'
import { store } from '@/store'
import Tenant from "@/types/Tenant.interface";

export default {
    //  Hnadles the TenantSet event
    onTenantSet(tenant: Tenant): void {
        //  Get the currently authenticated user (there should always be an authenticated user when this function is called)
        const user = store.getters.user

        //  Check if the user has a verified email
        const verified = user.email_verified

        //  If the user's email is not verified
        if (!verified) {
            //  wait 10 seconds and pop the email verification notificaton
            setTimeout(() => {
                store.commit('appNotificationBarSet', {
                    message: 'Your email ' + store.getters.user.email + ' has not been verified yet!',
                    type: 'success',
                    closeable: true,
                    link: '/teammates?verifyEmail=true&user=myUserProfile',
                    btnText: 'Click to send verification code',
                    btnMethod: null
                })

                return
            }, 10000)
        }

        //  Check if the user has a verified phone
        const mobileVerified = user.mobilephone_verified

        //  If the user's mobilephone is not verified
        if (!mobileVerified) {

            //  wait 10 seconds and pop the phone verification notificaton
            setTimeout(() => {
                store.commit('appNotificationBarSet', {
                    message: 'Your phone ' + filters.phone(store.getters.user.mobilephone) + ' has not been verified yet!',
                    type: 'success',
                    closeable: true,
                    link: '/teammates?verifyPhone=true&user=myUserProfile',
                    btnText: 'Click to send verification code',
                    btnMethod: null
                })
            }, 10000)
        }
    }
}
